// const tab_heading = document.querySelectorAll(".tab__hdngs .tab__hdng");
// const tab_content = document.querySelectorAll(".tab__cntnts .tab__cntnt");

// tab_heading.forEach((heading, index) => {
//   heading.addEventListener("click",() => {
//     document.querySelector(".tab__hdngs .tab__hdng.active")?.classList.remove("active");
//     document.querySelector(".tab__cntnts .tab__cntnt.active")?.classList.remove("active");
//     heading.classList.add("active");
//     tab_content[index].classList.add("active");
//   });
// });

// tab_heading[0].classList.add("active");
// tab_content[0].classList.add("active");


const tab_heading = document.querySelectorAll(".tab__hdngs .tab__hdng");
const tab_content = document.querySelectorAll(".tab__cntnts .tab__cntnt");

// Validate presence of tabs
if (tab_heading.length === 0 || tab_content.length === 0) {
  console.warn("Tab headings or content not found. Check your HTML structure.");
} else {
  tab_heading.forEach((heading, index) => {
    heading.addEventListener("click", () => {
      const activeHeading = document.querySelector(".tab__hdngs .tab__hdng.active");
      const activeContent = document.querySelector(".tab__cntnts .tab__cntnt.active");

      if (activeHeading) activeHeading.classList.remove("active");
      if (activeContent) activeContent.classList.remove("active");

      heading.classList.add("active");

      if (tab_content[index]) {
        tab_content[index].classList.add("active");
      } else {
        console.warn(`No content found for tab index ${index}`);
      }
    });
  });

  // Set default active tab only if they exist
  if (tab_heading[0]) tab_heading[0].classList.add("active");
  if (tab_content[0]) tab_content[0].classList.add("active");
}



// Read More/Read Less metafield content
document.addEventListener("DOMContentLoaded", function () {
  var specEls = document.querySelectorAll(".tab__cntnts .tab__cntnt__inner");

  specEls.forEach(function (specEl) {
    var text = specEl.innerText || specEl.textContent;
    var charCount = text.trim().length;

    if (charCount > 200) {
      // Set initial styles
      specEl.style.overflow = "hidden";
      specEl.style.transition = "max-height 0.4s ease";
      specEl.style.maxHeight = "170px";

      // Create the toggle button
      var toggleBtn = document.createElement("button");
      toggleBtn.classList.add("toggle_btn");
      toggleBtn.innerText = "Read More";
      toggleBtn.setAttribute("type", "button");
      toggleBtn.style.marginTop = "10px";
      toggleBtn.style.display = "inline-block";

      // Insert button after the content block
      specEl.insertAdjacentElement("afterend", toggleBtn);

      let expanded = false;

      toggleBtn.addEventListener("click", function () {
        if (!expanded) {
          specEl.style.maxHeight = specEl.scrollHeight + "px";
          toggleBtn.innerText = "Read Less";
        } else {
          specEl.style.maxHeight = "170px";
          toggleBtn.innerText = "Read More";
        }
        expanded = !expanded;
      });
    }
  });
});
// Read More/Read Less metafield content


